import Layout from "../Layout";

export default [
  {
    path: "/tm",
    name: "tm",
    component: Layout
  }
];
